import { gql } from '@apollo/client';

export const UPDATE_EXTERNAL_CONTENT_MUTATION = gql`
  mutation UpdateExternalContent($data: updateExternalContentInput!) {
    updateExternalContent(input: $data) {
      externalContent {
        id
        title
        body
        hashtags
        publicationState
        platform
        post {
          id
        }
      }
    }
  }
`;
